import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useCorporatePnlTemplateByIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, pnlId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _pnlId = isRef<string>(pnlId) ? pnlId : ref<string>(pnlId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		pnlId: _pnlId,
		...useQuery(() => new q.CorporatePnlTemplateByIdQueryV1(_workspaceId.value, _strategyId.value, _pnlId.value))
	}
	return {
		...result,
		runCorporatePnlTemplateByIdQueryV1: result.run,
		modelCorporatePnlTemplateByIdQueryV1: result.model,
	}
}

export function useCorporatePnlTemplatesByStrategyIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.CorporatePnlTemplatesByStrategyIdQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runCorporatePnlTemplatesByStrategyIdQueryV1: result.run,
		modelCorporatePnlTemplatesByStrategyIdQueryV1: result.model,
	}
}

export function useDefaultPnlTemplateByIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, templateId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _templateId = isRef<string>(templateId) ? templateId : ref<string>(templateId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		templateId: _templateId,
		...useQuery(() => new q.DefaultPnlTemplateByIdQueryV1(_workspaceId.value, _strategyId.value, _templateId.value))
	}
	return {
		...result,
		runDefaultPnlTemplateByIdQueryV1: result.run,
		modelDefaultPnlTemplateByIdQueryV1: result.model,
	}
}

export function usePnlsPageQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.PnlsPageQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runPnlsPageQueryV1: result.run,
		modelPnlsPageQueryV1: result.model,
	}
}

